import Link from "next/link";
import { VoteCardListModule } from "~/components/Modules/Vote/VoteCardListModule";
import { VoteHeaderModule } from "~/components/Modules/Vote/VoteHeaderModule";

type Props = {
  voteHeaderModuleProps: React.ComponentProps<typeof VoteHeaderModule>;
  voteCardListModuleProps: React.ComponentProps<typeof VoteCardListModule>;
};

export const VoteTemplate = (props: Props) => {
  return (
    <div>
      <VoteHeaderModule {...props.voteHeaderModuleProps} />
      <VoteCardListModule {...props.voteCardListModuleProps} />
    </div>
  );
};
